// src/config.js
// Centralized API base URL config

// export const API_BASE_URL = "https://digital.webdoc.com.pk/ci4webdocsite/public/api/v1";
export const API_BASE_URL = "https://webdocsite.webddocsystems.com/public/api/v1";
